/** Adopted from https://stackoverflow.com/a/2270987/4046605 */
export function getRanges(numbers: readonly number[]) {
  const sortedNumbers = numbers.toSorted((a, b) => a - b);
  const ranges = [];
  for (let i = 0; i < sortedNumbers.length; i++) {
    const rangeStart = sortedNumbers[i];
    let rangeEnd = rangeStart;
    while (sortedNumbers[i + 1] - sortedNumbers[i] === 1) {
      rangeEnd = sortedNumbers[i + 1];
      i += 1;
    }
    ranges.push(rangeStart === rangeEnd ? rangeStart.toString() : `${rangeStart}-${rangeEnd}`);
  }
  return ranges;
}
